<template>
  <div class="card">
    <div>
      <span
        class="level-badge"
        :style="{ backgroundColor: content.color }"
      >
        {{ content.level }}
      </span>

      <span class="project-title">
        {{ content.name }}
      </span>

      <div class="project-type-container">
        <span class="block text-black mb-1">Project Type:</span>
        <b>{{ content.projectType }}</b>
      </div>
    </div>

    <div v-html="domPurify.sanitize(content.description)" />
  </div>
</template>

<script setup>
import { useDomPurify } from '@/composables/index.js';

const domPurify = useDomPurify();

const props = defineProps({
  contentItem: {
    type: Object,
    required: true,
  },
});

const content = props.contentItem.value;
</script>
